export default __webpack_public_path__ + "static/media/ab02.2dba2032.jpg";